import type { ComponentType } from 'react';
import type { SupportedLocales } from '@/i18n/i18n';
import TermsOfUseEn from './content/terms-of-use.en';
import TermsOfUseDe from './content/terms-of-use.de';
import PrivacyPolicyEn from './content/privacy-policy.en';
import PrivacyPolicyDe from './content/privacy-policy.de';
import CookiePolicyEn from './content/cookie-policy.en';
import CookiePolicyDe from './content/cookie-policy.de';

export type LocalizedString = Record<SupportedLocales, string>;
export type LocalizedComponent = Record<SupportedLocales, ComponentType>;

export interface LegalDocument {
  slug: string;
  title: LocalizedString;
  description: LocalizedString;
  component: LocalizedComponent;
}

export const legalDocuments: LegalDocument[] = [
  {
    slug: 'terms',
    title: {
      en: 'Terms of Use',
      de: 'Nutzungsbedingungen',
    },
    description: {
      en: 'General User Terms of Use governing the use of the BRITESTAGE platform.',
      de: 'Allgemeine Nutzungsbedingungen für die Nutzung der BRITESTAGE-Plattform.',
    },
    component: {
      en: TermsOfUseEn,
      de: TermsOfUseDe,
    },
  },
  {
    slug: 'privacy',
    title: {
      en: 'Privacy Policy',
      de: 'Datenschutzerklärung',
    },
    description: {
      en: 'How we collect, use, and protect your personal data on the BRITESTAGE platform.',
      de: 'Wie wir Ihre personenbezogenen Daten auf der BRITESTAGE-Plattform erheben, verwenden und schützen.',
    },
    component: {
      en: PrivacyPolicyEn,
      de: PrivacyPolicyDe,
    },
  },
  {
    slug: 'cookies',
    title: {
      en: 'Cookie Policy',
      de: 'Cookie-Richtlinie',
    },
    description: {
      en: 'How BRITESTAGE uses cookies and similar technologies, and how you can control them.',
      de: 'Wie BRITESTAGE Cookies und ähnliche Technologien einsetzt und wie Sie diese steuern können.',
    },
    component: {
      en: CookiePolicyEn,
      de: CookiePolicyDe,
    },
  },
];

export function findLegalDocument(slug: string): LegalDocument | undefined {
  return legalDocuments.find((doc) => doc.slug === slug);
}
